import Tracker from '@openreplay/tracker';

const tracker = new Tracker({
    // projectKey: 'hPlSJxSpvpCI9YQHKNbl',
    projectKey: process.env.REACT_APP_OPEN_REPLAY_PROJECT_KEY || 'fake-id',
    // __DISABLE_SECURE_MODE: true, // allows local testing
    // ingestPoint: 'https://openreplay.somehostname/ingest', // use something like this if self-hosting
});

export default tracker;
